/* AimGrips Landing Page JS — announcement rotation, sticky mobile CTA, quick add */
(function () {
  'use strict';

  /* Announcement bar rotation */
  document.querySelectorAll('[data-ag-rotator]').forEach(function (rot) {
    var msgs = rot.querySelectorAll('.ag-announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    var speed = parseInt(rot.getAttribute('data-speed'), 10) || 4500;
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, speed);
  });

  /* Sticky mobile CTA — appears once the hero scrolls out of view */
  var sticky = document.querySelector('[data-ag-sticky]');
  var hero = document.querySelector('[data-ag-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0.1 }).observe(hero);
  }

  /* Quick add — AJAX add to cart with graceful fallback to normal form post */
  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    /* Dawn-style cart icon bubble re-render (no-op on other themes) */
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && data['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
          if (inner) el.innerHTML = inner.innerHTML;
        }
      })
      .catch(function () {});
  }

  document.querySelectorAll('form[data-ag-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('button[type="submit"]');
      var idInput = form.querySelector('[name="id"]');
      if (!btn || !idInput || !window.fetch) return; /* fall back to normal POST */
      e.preventDefault();
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-adding-text') || 'Adding…';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          btn.textContent = btn.getAttribute('data-added-text') || 'Added ✓';
          refreshCartUI();
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          form.submit(); /* full-page fallback */
        });
    });
  });
})();
